// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/54860baec49a4507bccd.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"ff63c6c5276ae6bf2b71","218":"b198c21ea7fbdb1cb4b6","219":"769a84b17bc6369897b2"}[chunkId] + ".chunk.js";
};